define.alias("shared/components/shared/date-time-picker", "media/components/shared/date-time-picker");